import { Alert, Stack } from "@mui/material";
import PageDeactivatedAlert from "../PageDeactivatedAlert";
import FundraisingConfigurationSection from "./FundraisingConfigurationSection";
import FundraisingDetailsSection from "./FundraisingDetailsSection";
import useFundraisingDetailsPageContext from "./useFundraisingDetailsPageContext";

const FundraisingOverview = () => {
  const { fundraising, isPageDeactivatedOnPortal } = useFundraisingDetailsPageContext();

  return (
    <Stack spacing={1.5} sx={{ flex: 1, py: 2.5 }}>
      {isPageDeactivatedOnPortal && <PageDeactivatedAlert />}
      {fundraising.status === "Preview" && (
        <Alert severity="info">
          This fundraising is in Preview. Publish to Live to start sharing information and collecting document activity.
        </Alert>
      )}
      <FundraisingDetailsSection />
      <FundraisingConfigurationSection />
    </Stack>
  );
};

export default FundraisingOverview;
